import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { withCommas } from '../common/Utils';
import { numToKor } from '../common/numToKor';
import { FavoriteBtn } from '../components/FavoriteBtn';
import useRouter from '../hook/useRouter';
import { IPriceItem } from '../interface/IPrice';
import { RootState, store } from '../store';
import { PriceItemStock } from './PriceItemStock';

export const PriceItem = ({ it, svrid }: { it: IPriceItem; svrid: string }) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const service = useSelector((state: RootState) => state.main.config.service);
    const numChangeFn = service === 'lms' ? numToKor : withCommas;
    const [isopen, isopenSet] = useState(false);
    const [qtity, qtitySet] = useState(it.quantity);
    const { changeParam } = useRouter([]);

    return (
        <div className={`tablerow ${isopen ? 'is-active' : ''}`} data-id={it.itemId}>
            <div className="tablecell favorite">
                <FavoriteBtn itemId={it.itemId} isFav={it.favorite} type={'item'} ga360str={'시세_리스트_즐겨찾기_클릭'} />
            </div>
            <div className="tablecell itemname">
                <button className="btn-item" onClick={() => changeParam({ detail: `item_${it.itemId}_${it.enchantLevel}_${it.serverId}` })}>
                    <img
                        className="thumb"
                        alt={it.itemName}
                        src={it.image}
                        onError={(e) => {
                            e.currentTarget.src = store.getState().main.config.wstatic + '/plaync/gameinfo/img/thumb-' + service + '.png';
                        }}
                    />
                    <strong
                        className="name"
                        data-itemgrade={it.grade}
                        data-areas="시세_리스트_아이템_클릭"
                        data-contents={`${it.enchantLevel > 0 ? `+${it.enchantLevel} ` : ''}${it.itemName}`}
                    >
                        {it.enchantLevel > 0 ? `+${it.enchantLevel}` : ''} {it.itemName}
                    </strong>
                </button>
            </div>

            {svrid === 'all' ? (
                <div className="tablecell server">
                    {it.serverName}
                    {it.world ? ` ${l10n['price.world']}` : null}
                </div>
            ) : null}

            <div className="tablecell min-price">
                {it.nowMinUnitPrice > 0 ? (
                    <>
                        {it.world ? <i className="ico-world"></i> : null}
                        <i className="ico-price"></i>
                        <strong className="price">{numChangeFn(it.nowMinUnitPrice)}</strong>
                    </>
                ) : (
                    `${l10n['noti.noitems']}`
                )}
            </div>

            {svrid !== 'all' ? (
                <div className="tablecell avg-price">
                    {it.world ? <i className="ico-world"></i> : null}
                    <i className="ico-price"></i>
                    <strong className="price">{numChangeFn(it.avgUnitPrice)}</strong>
                </div>
            ) : null}

            <div className="tablecell qty">
                <i className="ico-tradeable"></i>
                <strong className="qty">{qtity > 99 ? '99+' : qtity}</strong>
                {it.quantity > 0 ? (
                    <button
                        className="btn-folder"
                        data-areas="시세_리스트_매물열기_클릭"
                        onClick={() => isopenSet((current) => !current)}
                    ></button>
                ) : null}
            </div>

            <PriceItemStock it={it} isopen={isopen} qtitySet={qtitySet} />
        </div>
    );
};
